import axios from "axios";
import Interface from "./Interface";

export default class OrlenPaczka extends Interface
{
    getSlug()
    {
        return 'orlen_paczka';
    }

    getName() 
    {
        return 'Orlen Paczka'
    }

    getLogo() 
    {
        return '/img/deliveries/logo-orlen.svg';
    }

    getPinIcon()
    {
        return {
            iconUrl: '/img/deliveries/pin-orlen.png',
            iconSize: [64,64]
        };
    }

    async getPins()
    {
        const pins = await axios.get('./?a=options.jsonDeliveryMapPoints&module=orlen')
            .then(r => r.data)
            .then(r => r.data)
            .then(response => {
                return response;
            })
            .catch(error => {
                alert('Wystąpił problem podczas pobierania danych');
            });
        return pins;
    }
}